"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Drawer = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var react_dom_1 = tslib_1.__importDefault(require("react-dom"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var create_rocket_1 = require("../_util/create-rocket");
var justify_1 = require("../justify");
var button_1 = require("../button");
var transition_1 = require("../transition");
var use_outside_click_1 = require("../_util/use-outside-click");
var heading_1 = require("../heading");
var config_context_1 = require("../_util/config-context");
var use_visible_transition_1 = require("../_util/use-visible-transition");
var call_both_1 = require("../_util/call-both");
var noop_1 = require("../_util/noop");
var uuid_1 = require("../_util/uuid");
var z_stack_1 = require("../_util/z-stack");
var backdrop_1 = require("../backdrop");
var use_overlay_focus_1 = require("../_util/use-overlay-focus");
var get_overlay_root_1 = require("../_util/get-overlay-root");
var i18n_1 = require("../i18n");
var util_1 = require("../util");
exports.Drawer = react_1.default.forwardRef(function Drawer(_a, fRef) {
    var _b, _c;
    var className = _a.className, _d = _a.style, style = _d === void 0 ? {} : _d, children = _a.children, visible = _a.visible, _e = _a.onClose, onClose = _e === void 0 ? noop_1.noop : _e, _f = _a.onExited, onExited = _f === void 0 ? noop_1.noop : _f, size = _a.size, placement = _a.placement, footer = _a.footer, title = _a.title, subTitle = _a.subTitle, _g = _a.subtitle, subtitle = _g === void 0 ? subTitle : _g, extra = _a.extra, disableCloseIcon = _a.disableCloseIcon, disableAnimation = _a.disableAnimation, _h = _a.outerClickClosable, outerClickClosable = _h === void 0 ? true : _h, _j = _a.destroyOnClose, destroyOnClose = _j === void 0 ? true : _j, _k = _a.showMask, showMask = _k === void 0 ? false : _k, _l = _a.maskStyle, maskStyle = _l === void 0 ? {} : _l, popupContainer = _a.popupContainer;
    var _m = config_context_1.useConfig(), classPrefix = _m.classPrefix, globalPopupContainer = _m.popupContainer;
    var t = i18n_1.useTranslation();
    var ref = react_1.useRef(null);
    var focusRef = react_1.useRef(null);
    var idRef = react_1.useRef(uuid_1.uuid());
    var firstRender = react_1.useRef(!!visible);
    var _o = use_outside_click_1.useOutsideClick(ref), listen = _o.listen, ignoreProps = _o.ignoreProps;
    listen(function () {
        return outerClickClosable && visible && z_stack_1.zStack.top === idRef.current && onClose();
    });
    if (visible && !firstRender.current) {
        firstRender.current = true;
    }
    var width = size === "l" ? 800 : 320;
    var from = placement === "left" ? 0 - width : width;
    var showHeader = title || subtitle || extra || !disableCloseIcon;
    var _p = use_visible_transition_1.useVisibleTransition(visible), contentIn = _p.contentIn, shouldContentEnter = _p.shouldContentEnter, shouldContentRender = _p.shouldContentRender, onContentExit = _p.onContentExit;
    react_1.useEffect(function () {
        if (contentIn) {
            var id_1 = idRef.current;
            z_stack_1.zStack.push(id_1);
            return function () {
                z_stack_1.zStack.remove(id_1);
            };
        }
        return noop_1.noop;
    }, [contentIn]);
    use_overlay_focus_1.useOverlayFocus(visible, focusRef);
    if (!shouldContentRender &&
        (destroyOnClose || (!destroyOnClose && !firstRender.current))) {
        return null;
    }
    return react_dom_1.default.createPortal(react_1.default.createElement("div", { tabIndex: -1, ref: focusRef, className: classnames_1.default((_b = {},
            _b[classPrefix + "-drawer-open"] = visible,
            _b)), style: {
            display: !destroyOnClose && !contentIn ? "none" : undefined,
        } },
        showMask && (react_1.default.createElement(transition_1.FadeTransition, { in: shouldContentEnter, opacity: 1 },
            react_1.default.createElement(backdrop_1.BackDrop, { zIndex: typeof style.zIndex !== "undefined" ? style.zIndex : 10, style: maskStyle }))),
        react_1.default.createElement(transition_1.SlideTransition, { in: shouldContentEnter, from: [from, 0], timeout: disableAnimation ? 0 : undefined, unmountOnExit: destroyOnClose, onExited: call_both_1.callBoth(onExited, onContentExit) },
            react_1.default.createElement("div", tslib_1.__assign({ ref: util_1.mergeRefs(ref, fRef), style: style, className: classnames_1.default(classPrefix + "-drawer", className, (_c = {},
                    _c[classPrefix + "-drawer--left"] = placement === "left",
                    _c["size-l"] = size === "l",
                    _c)) }, ignoreProps),
                showHeader && (react_1.default.createElement("div", { className: classPrefix + "-drawer__header" },
                    react_1.default.createElement(justify_1.Justify, { left: react_1.default.createElement(DrawerTitle, { title: title, subtitle: subtitle, classPrefix: classPrefix }), right: react_1.default.createElement(react_1.default.Fragment, null,
                            extra,
                            !disableCloseIcon && (react_1.default.createElement(button_1.Button, { icon: "close", htmlType: "button", onClick: onClose, "aria-label": t.closeText }))) }))),
                react_1.default.createElement(DrawerBody, null, children),
                footer && react_1.default.createElement(DrawerFooter, null, footer)))), get_overlay_root_1.getOverlayRoot(popupContainer || globalPopupContainer));
});
exports.Drawer.displayName = "Drawer";
function DrawerTitle(_a) {
    var title = _a.title, subtitle = _a.subtitle, classPrefix = _a.classPrefix;
    var sub = typeof subtitle === "string" ? (react_1.default.createElement("span", { className: classPrefix + "-card__subtitle" }, subtitle)) : (subtitle);
    if (typeof title === "string") {
        return (react_1.default.createElement(heading_1.H3, null,
            title,
            sub));
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        title,
        sub));
}
DrawerTitle.displayName = "DrawerTitle";
var DrawerBody = create_rocket_1.createRocket("DrawerBody", "div.@{prefix}-drawer__body", "div.@{prefix}-drawer__body-inner");
var DrawerFooter = create_rocket_1.createRocket("DrawerFooter", "div.@{prefix}-drawer__footer");
//# sourceMappingURL=Drawer.js.map